import { isDefined } from "@clipboard-health/util-ts";
import { useRef } from "react";

import { PageWrapper } from "../../../../components/PageWrapper";
import { StickyScrollPageHeader } from "../../../../components/StickyScrollPageHeader";
import { DocumentStatusCard } from "../../../components/StatusCard";
import { DocumentStatusCardActionButton } from "../../../components/StatusCardActionButton";
import { useOpenDocument } from "../../../useOpenDocument";
import { DocumentUploadFooter } from "../../Footer";
import { DocumentDetailsInstructions } from "../../Instructions";
import { DocumentDetailsMetadata } from "../../Metadata";
import { DocumentPageScrollWrapper } from "../../ScrollWrapper";
import { useDocumentDetailsActions } from "../../useDocumentDetailsActions";
import { useRequirementDetailsContext } from "../../useRequirementDetailsContext";
import { useRequirementPrerequisiteActions } from "../../useRequirementPrerequisiteActions";

export function MiscellaneousDocumentPage() {
  const { requirement: workerRequirement, uploadedDocument } = useRequirementDetailsContext();
  const scrollRef = useRef<HTMLDivElement>(null);
  const { status, requirement } = workerRequirement;
  const { name } = requirement?.attributes ?? {};

  const { onClick: openDocument, isLoading: isOpeningDocument } = useOpenDocument();

  const { uploadDocument } = useDocumentDetailsActions();
  const { withPrerequisiteCheck, prerequisiteBottomSheet } = useRequirementPrerequisiteActions();

  return (
    <PageWrapper variant="tertiary">
      <StickyScrollPageHeader
        shouldWrapTitle
        title={name ?? ""}
        headerVariant="tertiary"
        scrollContainerRef={scrollRef}
      />

      <DocumentPageScrollWrapper ref={scrollRef}>
        <DocumentDetailsMetadata />
        {isDefined(uploadedDocument) && (
          // we only allow to view the document that was just uploaded. It will always be in review
          // and later moved to a specific requirement by support person
          <DocumentStatusCard variant="in_review" isLoading={isOpeningDocument}>
            <DocumentStatusCardActionButton
              onClick={async () => {
                await openDocument(uploadedDocument.id);
              }}
            />
          </DocumentStatusCard>
        )}
        <DocumentDetailsInstructions />
      </DocumentPageScrollWrapper>

      <DocumentUploadFooter
        status={status}
        resubmissionDisabledFor={requirement?.attributes?.resubmissionDisabledFor}
        onUploadButtonClick={withPrerequisiteCheck(uploadDocument)}
      />
      {prerequisiteBottomSheet}
    </PageWrapper>
  );
}
